module.exports = __webpack_public_path__ + "img/rutas.63e3116c.png";